import React, { useState, useEffect } from 'react';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import Header from '../../../header/header.js';
import Navvbar from '../../../header/Navvbar.js';
import Swal from 'sweetalert2';
import { useCurrency } from '../../../../context/currencyContext';
import EditInvoice from './EditInvoice.js';
import './invoiceDetails.css';

// Styles
const styles = {
  pageContainer: {
    minHeight: '100vh',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  sidebar: {
    borderRight: '1px solid #e5e5e5',
    minHeight: 'calc(100vh - 70px)',
    padding: '20px 0',
    backgroundColor: '#ffffff',
  },
  sidebarTitle: {
    margin: '15px 0 20px 30px',
    color: '#004aad',
    fontSize: '22px',
    fontWeight: '600',
  },
  sidebarLink: {
    textDecoration: 'none',
    color: '#0056b3',
    fontWeight: '500',
    fontSize: '16px',
    display: 'block',
    margin: '0 30px 15px',
    padding: '8px 12px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease, color 0.2s ease',
  },
  contentWrapper: {
    padding: '30px',
  },

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
    paddingBottom: '15px',
  },
 invoiceHeading: {
  fontSize: '30px',
  color: '#262626',
  marginLeft: '-20px',
  marginTop:"-50px",
},
  caseLink: {
    color: '#004aad',
    textDecoration: 'none',
    fontWeight: '600',
    transition: 'color 0.2s ease',
  },
  actionButtonContainer: {
    position: 'relative',
  },
  actionButton: {
    padding: '10px 20px',
    backgroundColor: '#004aad',
    color: '#fff',
    border: 'none',
    borderRadius: '6px',
    fontWeight: '500',
    fontSize: '14px',
    cursor: 'pointer',
    boxShadow: '0 2px 4px rgba(0,74,173,0.2)',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
  },
  dropdown: {
    position: 'absolute',
    top: 'calc(100% + 8px)',
    right: 0,
    backgroundColor: '#fff',
    border: '1px solid #e5e5e5',
    borderRadius: '6px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    zIndex: 1000,
    width: '180px',
    overflow: 'hidden',
  },
  dropdownItem: {
    padding: '10px 15px',
    cursor: 'pointer',
    fontSize: '14px',
    color: '#333',
    borderBottom: '1px solid #f0f0f0',
    transition: 'background-color 0.2s ease',
  },
  itemsSection: {
    marginBottom: '20px',
  },
  itemsTable: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '12px',
  },
  tableHeader: {
    backgroundColor: '#f4f4f4',
    color: '#333',
    fontWeight: 'bold',
    height: '50px',
  },
  tableCell: {
    borderBottom: '2px solid #dddddd',
    padding: '6px 4px',
    textAlign: 'left',
    lineHeight: '1.2',
  },

  textRight: {
    textAlign: 'right',
  },
  textCenter: {
    textAlign: 'center',
  },
  tableRowEven: {
    backgroundColor: '#f8f9fa',
  },
  summarySection: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '15px',
  },
  summaryTable: {
    width: '100%',
    maxWidth: '100%',
    fontSize: '13px',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
  },
  summaryRow: {
    padding: '4px 10px',
  },
  summaryLabel: {
    textAlign: 'left',
    fontWeight: '600',
    color: '#444',
    padding: '4px 10px',
    lineHeight: '1.2',
  },
  summaryValue: {
    textAlign: 'right',
    color: '#333',
    padding: '4px 10px',
    lineHeight: '1.2',
  },
  totalRow: {
    fontWeight: 'bold',
    color: '#333',
    fontSize: '15px',
  },
  footerSection: {
    textAlign: 'center',
    marginTop: '40px',
    paddingTop: '20px',
    fontSize: '11px',
    color: '#666',
  },
  thankYou: {
    color: '#4CAF50',
    fontStyle: 'italic',
    display: 'block',
    marginTop: '8px',
    fontSize: '12px',
  },
  loadingError: {
    textAlign: 'center',
    marginTop: '60px',
    fontSize: '18px',
    padding: '20px',
    color: '#d9534f',
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  detailsGrid: {
    display: "flex",
    justifyContent: "center",
    marginTop: "-130px",
    marginBottom: "30px",
  },
  detailsColumn: {
    width: "260px",
  },
  detailItem: {
    marginBottom: "8px",
    textAlign: "left",
  },
  detailHeading: {
    fontWeight: "700",
    fontSize: "18px",
    color: "#222",
    marginBottom: "2px",
  },
  detailValue: {
    marginLeft: "30px",
    fontSize: "16px",
    color: "#444",
  },
  blueValue: {
    marginLeft: "30px",
    fontSize: "16px",
    color: "#2f6eb5bb",
  },
 clinicInfo: {
  fontSize: '14px',
  color: '#333',
  lineHeight: '1.6',
  marginLeft: '50px', // right side shift hoga
},
};

const transitionStyles = `
  .fade-enter {
    opacity: 0;
  }
  .fade-enter-active {
    opacity: 1;
    transition: opacity 300ms ease-in;
  }
  .fade-exit {
    opacity: 1;
  }
  .fade-exit-active {
    opacity: 0;
    transition: opacity 300ms ease-out;
  }
  
  @media print {
    .print-only-lab-info {
      display: block !important;
    }
    .screen-only-header {
      display: none !important;
    }
  }
  
  @media screen {
    .print-only-lab-info {
      display: none !important;
    }
    .screen-only-header {
      display: flex !important;
    }
  }
`;
// Function to get userLabId from localStorage (same pattern as Case.js)
const getUserLabId = () => {
  try {
    const possibleKeys = [
      "user",
      "userData",
      "auth",
      "currentUser",
      "labUser",
      "labUserData",
    ];

    for (const key of possibleKeys) {
      const storedData = localStorage.getItem(key);

      if (storedData) {
        try {
          const parsed = JSON.parse(storedData);

          const userLabId =
            parsed.userLabId ||
            parsed.labId ||
            parsed.id ||
            parsed.data?.userLabId ||
            parsed.data?.labId ||
            parsed.user?.userLabId ||
            parsed.user?.labId;

          if (userLabId) {
            return userLabId;
          }

          if (
            typeof storedData === "string" &&
            storedData.match(/^000000\d{2}$/)
          ) {
            return storedData;
          }
        } catch (e) {
          continue;
        }
      }
    }

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const value = localStorage.getItem(key);

      if (value && value.match(/^000000\d{2}$/)) {
        return value;
      }
    }

    return null;
  } catch (error) {
    console.error("Error getting userLabId from localStorage:", error);
    return null;
  }
};

const InvoiceDetail = () => {
  
  const { formatAmount } = useCurrency();
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();
  const [showEditModal, setShowEditModal] = useState(false);
  const navigate = useNavigate();
  const { invoiceData: initialInvoiceData } = location.state || {};
  const [invoiceData, setInvoiceData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const { invoiceNumber } = useParams();
  const [visiblePages, setVisiblePages] = useState([]);
  const [userId, setUserId] = useState(null);
  const [userRole, setUserRole] = useState('');

  const [accountInfo, setAccountInfo] = useState(null);
  const [providerInfo, setProviderInfo] = useState(null);
  const [labInfo, setLabInfo] = useState(null);
  const [providerLoading, setProviderLoading] = useState(false);

  // Print prevention handlers
  useEffect(() => {
    const handleContextMenu = (e) => {
      e.preventDefault();
      return false;
    };

    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === 'p') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      if (e.key === 'PrintScreen' || e.key === 'Print') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    const handleBeforePrint = (e) => {
      e.preventDefault();
      return false;
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    window.addEventListener('beforeprint', handleBeforePrint);
    window.addEventListener('keyup', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('beforeprint', handleBeforePrint);
      window.removeEventListener('keyup', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const originalPrint = window.print;

    window.print = function() {
      return;
    };

    return () => {
      window.print = originalPrint;
    };
  }, []);

  useEffect(() => {
    const fetchCurrentUserLabInfo = async () => {
      try {
        const token = localStorage.getItem("token");
        const userId = localStorage.getItem("userId");

        if (!userId) {
          console.log("No user ID found in localStorage");
          return;
        }

        console.log("Fetching data for user ID:", userId);

        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/auth/users/${userId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data) {
          const userData = response.data;
          console.log("Current user data fetched:", userData);

          setLabInfo({
            labName: userData.labName || "",
            fullName: `${userData.first_name || ""} ${userData.last_name || ""}`.trim() || "",
            address: userData.address || "",
            address2: userData.address2 || "",
            city: userData.city || "",
            state: userData.state || "",
            zipCode: userData.zipCode || "",
            telephone: userData.telephone || "",
            email: userData.labEmail || userData.email || ""
          });
        }
      } catch (err) {
        console.error("Current user lab info fetch error:", err);
      }
    };
    fetchCurrentUserLabInfo();
  }, []);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.type = 'text/css';
    styleSheet.innerText = transitionStyles;
    document.head.appendChild(styleSheet);

    return () => {
      document.head.removeChild(styleSheet);
    };
  }, []);

 useEffect(() => {
  const storedUserId = localStorage.getItem('userId');
  const storedUserRole = localStorage.getItem('userRole');

  setUserId(storedUserId);
  setUserRole(storedUserRole || '');
}, []);

  useEffect(() => {
  if (userId && userRole !== 'Admin') {
    const fetchPermissions = async () => {
        try {
          const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/page/user/${userId}/pages`, {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
            },
          });
          if (!response.ok) {
            throw new Error('Failed to fetch permissions');
          }
          const data = await response.json();
          setVisiblePages(data.map(perm => perm.page.name));
        } catch (error) {
          console.error('Error fetching permissions:', error);
        }
      };
      fetchPermissions();
    }
}, [userId, userRole]);

  // Auto-open the Edit Invoice modal when we've been sent here from the
  // Case page right after adding/editing/deleting a procedure. Respects
  // the same edit permission used by the "Edit" dropdown option below.
useEffect(() => {
  const canEdit =
    userRole === 'Admin' ||
    visiblePages.includes('Edit Invoice');

  if (location.state?.openEditModal && canEdit) {
    setShowEditModal(true);
  }
}, [location.state, userRole, visiblePages]);

  // NOTE: The previous auto-sync-on-open effect that called
  // PUT /api/invoices/update-from-case/:caseId here has been removed.
  // That call persisted case procedures into the invoice immediately on
  // page load, before you ever opened the Edit modal or clicked "Update
  // Invoice". Procedures are now pulled live into the Edit modal itself
  // (see EditInvoiceModal.js) and are only written to the invoice when you
  // explicitly click "Update Invoice" there.

  const fetchAccountDetails = async (accountId) => {
    try {
      const response = await axios.get(`https://hms.backend.hiragroupcloud.com/api/account/account/${accountId}`);
      if (response.data) {
        setAccountInfo(response.data);
        return response.data;
      }
      return null;
    } catch (error) {
      console.error('Error fetching account details:', error);
      return null;
    }
  };

  const fetchProviderFromContacts = async (accountId) => {
    if (!accountId) return null;

    try {
      setProviderLoading(true);

      console.log("Fetching provider for account:", accountId);

      const response = await axios.get(
        `https://hms.backend.hiragroupcloud.com/api/contacts/${accountId}`
      );

      console.log("Contacts API Response:", response.data);

      if (
        response.data &&
        response.data.data &&
        Array.isArray(response.data.data) &&
        response.data.data.length > 0
      ) {
        const contact = response.data.data[0];

        const providerName = [
          contact.title,
          contact.firstName,
          contact.middleInitial,
          contact.lastName,
        ]
          .filter(Boolean)
          .join(" ");

        setProviderInfo({
          ...contact,
          account_name: providerName,
        });

        return {
          ...contact,
          account_name: providerName,
        };
      }

      return null;
    } catch (error) {
      console.error("Error fetching contacts:", error);

      return null;
    } finally {
      setProviderLoading(false);
    }
  };

  const isInvoiceDataComplete = (data) => {
    return (
      data &&
      data.invoiceNumber &&
      data.total != null &&
      data.subtotal != null &&
      data.taxes != null &&
      data.paid != null &&
      Array.isArray(data.items)
    );
  };
  useEffect(() => {
    const fetchInvoiceData = async () => {
      try {
        // Get userLabId from localStorage to send with request
        const userLabId = getUserLabId();
        const headers = {};
        if (userLabId) {
          headers["x-user-lab-id"] = userLabId;
        }

        if (
          initialInvoiceData &&
          String(initialInvoiceData.invoiceNumber) === invoiceNumber &&
          isInvoiceDataComplete(initialInvoiceData)
        ) {
          const updatedInvoice = {
            ...initialInvoiceData,
            remaining: (parseFloat(initialInvoiceData.total) - parseFloat(initialInvoiceData.paid || 0)).toFixed(2),
          };
          setInvoiceData(updatedInvoice);

          if (updatedInvoice.accountId) {
            await fetchAccountDetails(updatedInvoice.accountId);
          }

          if (updatedInvoice.accountId) {
            await fetchProviderFromContacts(updatedInvoice.accountId);
          } else {
            console.log("No accountId found to fetch provider");
          }

          setLoading(false);
          return;
        }

        setLoading(true);
        console.log("Fetching invoice from API:", invoiceNumber);
        const response = await axios.get(
          `https://hms.backend.hiragroupcloud.com/api/invoices/${invoiceNumber}`,
          { headers }
        );
        console.log("Invoice API response:", response.data);

        if (response.data) {
          const invoice = {
            ...response.data,
            remaining: (parseFloat(response.data.total) - parseFloat(response.data.paid || 0)).toFixed(2),
          };
          setInvoiceData(invoice);

          console.log("Invoice accountId:", invoice.accountId);

          if (invoice.accountId) {
            const accountData = await fetchAccountDetails(invoice.accountId);
            console.log("Account data fetched:", accountData);
          }

          if (invoice.accountId) {
            console.log("Fetching provider from contacts for accountId:", invoice.accountId);
            await fetchProviderFromContacts(invoice.accountId);
          } else {
            console.log("No accountId found to fetch provider");

            if (invoice.provider_name) {
              console.log("Using provider_name from invoice:", invoice.provider_name);
              setProviderInfo({
                account_name: invoice.provider_name,
                id: invoice.providerId || invoice.accountId
              });
            }
          }

        } else {
          throw new Error('Invoice not found');
        }
        setLoading(false);
      } catch (err) {
        console.error('Error fetching invoice data:', err);

        // Handle 404 → "Invoice not found"
        if (err.response?.status === 404) {
          setError('Invoice not found');
        } else {
          setError('Failed to load invoice data: ' + (err.response?.data?.message || err.message));
        }
        setLoading(false);
      }
    };

    if (invoiceNumber) {
      fetchInvoiceData();
    } else {
      setError('Invoice number is missing.');
      setLoading(false);
    }
  }, [invoiceNumber, initialInvoiceData]);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };

  const formatCurrency = (value) => {
    const num = parseFloat(value);
    return isNaN(num) ? formatAmount(0) : formatAmount(num);
  };

  const calculateRate = (amount, quantity) => {
    const amountNum = parseFloat(amount) || 0;
    const quantityNum = parseFloat(quantity) || 1;
    return quantityNum === 0 ? 0 : amountNum / quantityNum;
  };

  const toUpperCase = (text) => {
    return text ? String(text).toUpperCase() : "";
  };

  const generateEmptyRows = (count = 25) => {
    let rows = '';
    for (let i = 0; i < count; i++) {
      rows += `
        <tr style="height: 15px;">
          <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;">&nbsp;</td>
          <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;">&nbsp;</td>
          <td style="border-bottom: 2px solid #ddd; text-align: right; padding: 4px 8px;">&nbsp;</td>
          <td style="border-bottom: 2px solid #ddd; text-align: right; padding: 4px 8px;">&nbsp;</td>
        </tr>
      `;
    }
    return rows;
  };

  const handleDelete = async () => {
    if (!window.confirm('Are you sure you want to delete this invoice? This action cannot be undone.')) {
      return;
    }
    try {
      setLoading(true);
      await axios.delete(`https://hms.backend.hiragroupcloud.com/api/invoices/delete-invoice/${invoiceNumber}`);
      alert('Invoice deleted successfully.');
      navigate('/casesOpened');
    } catch (err) {
      console.error('Error deleting invoice:', err);
      setError('Failed to delete invoice: ' + (err.response?.data?.message || err.message));
      setLoading(false);
    }
  };

  // Save as PDF - ONLY FIXING THE BORDER ISSUE WITHOUT CHANGING ANYTHING ELSE
const saveAsPDF = async (fileName) => {
  if (!invoiceData) {
    alert('Cannot generate PDF: Invoice data is missing.');
    return;
  }

  try {
    const htmlContent = generateInvoiceHTML();
    if (!htmlContent) {
      return;
    }

    const container = document.createElement('div');
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    container.style.top = '0';
    container.style.width = '1040px';
    container.style.background = 'white';
    container.style.zIndex = '-1';
    container.style.overflow = 'visible';
    container.style.boxSizing = 'border-box';
    container.style.padding = '20px';
    container.innerHTML = htmlContent;
    document.body.appendChild(container);

    await new Promise(resolve => setTimeout(resolve, 1500));

    // Extra space for safety
    const bufferSpace = document.createElement('div');
    bufferSpace.style.height = '30px';
    bufferSpace.style.width = '100%';
    container.appendChild(bufferSpace);

    const fullWidth = Math.ceil(container.scrollWidth);
    const fullHeight = Math.ceil(container.scrollHeight);

    const canvas = await html2canvas(container, {
      scale: 3,
      useCORS: true,
      logging: false,
      width: fullWidth,
      height: fullHeight,
      windowWidth: fullWidth,
      windowHeight: fullHeight,
      backgroundColor: '#ffffff',
      allowTaint: true,
 onclone: (clonedDoc) => {
  const clonedContainer = clonedDoc.querySelector('div');
  if (clonedContainer) {
    clonedContainer.style.transform = 'none';
  }

  // Final total row dhundo
  const finalRow = clonedDoc.querySelector('.print-only-total.final');

  if (finalRow) {
    const cells = finalRow.querySelectorAll('td');

    // Pehle saari borders clear karo
    cells.forEach(cell => {
      cell.style.border = 'none';
      cell.style.borderTop = 'none';
      cell.style.borderBottom = 'none';
      cell.style.borderLeft = 'none';
      cell.style.borderRight = 'none';
    });

    // Ab sirf 3rd aur 4th cell mein border lagao
    if (cells[2]) {
      cells[2].style.borderTop = '2px solid #000';
      cells[2].style.borderBottom = '2px solid #000';
    }
    if (cells[3]) {
      cells[3].style.borderTop = '2px solid #000';
      cells[3].style.borderBottom = '2px solid #000';
    }
  }
}
    });

    document.body.removeChild(container);

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = pdfHeight;
    let position = 0;
    const pageHeight = pdf.internal.pageSize.getHeight();

    pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
      heightLeft -= pageHeight;
    }

    pdf.save(fileName);
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('An error occurred while generating the PDF. Please try again.');
  }
};

  // generateInvoiceHTML - EXACTLY AS ORIGINAL, NO CHANGES
  const generateInvoiceHTML = () => {
    if (!invoiceData) {
      console.error('Cannot generate HTML for Print: Invoice data is missing.');
      alert('Cannot generate HTML for Print: Invoice data is missing.');
      return null;
    }

    const providerDisplayName = providerInfo?.account_name || invoiceData?.provider_name || 'Provider';

    const labName = labInfo?.labName || "Hira Dental Laboratory";
    const labAddress = labInfo?.address || "02 Ulverscroft Road";
    const labCity = labInfo?.city || "Coventry";
    const labState = labInfo?.state || "CV3";
    const labZip = labInfo?.zipCode || "5EZ";
    const labPhone = labInfo?.telephone || "024 7642 2500";
    const labEmail = labInfo?.email || "info@hiradentallab.com";

    const labCityStateZip = `${labCity}${labCity && labState ? ', ' : ''}${labState} ${labZip}`.trim();

    const accountName = accountInfo?.account_name || invoiceData.accountHolder || '';
    const accountAddress = accountInfo?.address || invoiceData.account_address || '';
    const accountCity = accountInfo?.city || '';
    const accountState = accountInfo?.state || '';
    const accountZip = accountInfo?.zip || '';
    const accountPhone = accountInfo?.telephone || invoiceData.account_phone || '';
    const patientName = invoiceData.patient_name || `${invoiceData.patientFirstName || ''} ${invoiceData.patientLastName || ''}`.trim() || 'N/A';
    const appointmentDate = invoiceData.appointmentDate ? formatDate(invoiceData.appointmentDate) : 'N/A';

    const fullAddress = accountAddress;
    const cityStateZip = `${accountCity}${accountCity && accountState ? ', ' : ''}${accountState} ${accountZip}`.trim();

    const formattedDate = invoiceData?.invoiceDate
      ? formatDate(invoiceData.invoiceDate)
      : 'N/A';

    const patientFullName = toUpperCase(
      `${invoiceData?.patientFirstName || ''} ${invoiceData?.patientLastName || ''}`
    ).trim() || 'N/A';

    return `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <title>Invoice - ${invoiceData.invoiceNumber || 'N/A'}</title>
        <style>
          .lab-account-wrapper {
            display: flex !important;
            flex-direction: row !important;
            align-items: flex-start !important;
            margin: 30px 0 30px 0 !important;
            padding: 0 !important;
            gap: 150px !important;
          }

          .lab-info-section {
            flex: 0 0 auto !important;
            margin-right: 25px !important;
            margin-bottom: 10px !important;
          }

          .lab-info-block {
            margin-bottom: 50px !important;
            padding-bottom: 25px !important;
          }

          .invoice-table th,
          .invoice-table td {
            border: 1px solid #3D3D3D !important;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            background: transparent !important;
            text-align: center !important;
            margin-top: 0 !important;
          }

          .invoice-table th:first-child,
          .invoice-table td:first-child {
            border-right: none !important;
          }

          .invoice-table th:nth-child(2),
          .invoice-table td:nth-child(2) {
            border-left: none !important;
          }

          .invoice-table th:first-child,
          .invoice-table td:first-child {
            width: 70% !important;
            text-align: left !important;
          }

          .invoice-table th:nth-child(2),
          .invoice-table td:nth-child(2) {
            width: 15% !important;
            text-align: center !important;
          }

          .invoice-table th:nth-child(3),
          .invoice-table td:nth-child(3) {
            width: 17.5% !important;
            text-align: right !important;
          }

          .invoice-table th:nth-child(4),
          .invoice-table td:nth-child(4) {
            width: 17.5% !important;
            text-align: right !important;
          }
          
          .invoice-table td:first-child {
            text-align: left !important;
          }
          
          .totals {
            display: none !important;
          }

          .print-only-total {
            display: table-row !important;
          }

          .print-only-total td {
            border-top: 2px solid #ddd !important;
            border-bottom: 2px solid #ddd !important;
          }

        
          
          .print-only-total td {
            border-top: 1px solid #3D3D3D !important;
            padding: 4px 8px !important;
          }
          
          .print-only-total td:nth-child(2) {
            border-right: none !important;
          }

          .print-only-total td:nth-child(3) {
            border-left: none !important;
          }

          .print-only-total.subtotal td {
            border-top: 2px solid #3D3D3D !important;
          }

          .print-only-total.final td {
            border-top: 2px solid #3D3D3D !important;
            border-bottom: 2px solid #3D3D3D !important;
          }
          
          .print-only-total td:first-child {
            border-top: none !important;
            border-bottom: none !important;
          }
          
          .print-only-total.subtotal td:first-child {
            border-top: none !important;
            border-bottom: none !important;
          }

          .print-only-total.final td:first-child {
            border-top: none !important;
            border-bottom: 2px solid #3D3D3D !important;
          }
          
          .invoice-table tbody tr td {
            border-bottom: 1px solid #3D3D3D !important;
          }
          
          .print-only-total td {
            border-bottom: 2px solid #3D3D3D !important;
          }
          
          .patient-line{
            align-items:flex-start !important;
          }

          .patient-name-wrap{
            display:inline-block !important;
            max-width:180px !important;
            word-wrap:break-word !important;
            overflow-wrap:break-word !important;
            white-space:normal !important;
          }

          .address-line-break {
            max-width: 250px !important;
          }

          .invoice-blue-text {
            color: #004aad !important;
            font-weight: bold !important;
          }

          .center-info-container {
            margin-bottom: -10px !important;
          }

          @page { 
            size: A4; 
            margin: 0; 
          }
          
          body {
            font-family: Arial, sans-serif;
            margin: 0;
            padding: 0;
            background: #fff;
            text-align: left;
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
          }

          .page-wrapper {
            width: 1000px;
            min-width: 1000px;
            max-width: 1000px;
            margin: 0;
            padding: 0;
          }
          
          .invoice {
            width: 1000px;
            max-width: 1000px;
            min-width: 1000px;
            font-size: 14px;
            padding: 2mm;
            box-sizing: border-box;
            page-break-after: always;
            page-break-inside: avoid;
            position: relative;
            min-height: 297mm;
            display: block;
          }
          
          .content-header { 
            display: flex; 
            justify-content: space-between; 
            align-items: flex-start; 
            padding-bottom: 10px; 
            margin-bottom: 15px; 
            margin-top: 15px; 
          }
          
          .logo { 
            width: 180px; 
            height: auto; 
          }
          
          table { 
            width: 100%; 
            border-collapse: collapse; 
            margin-top: 10px; 
          }
          
          th, td { 
            padding: 4px 8px; 
            font-size: 12px; 
            text-align: left;  
          }
          
          th { 
            background-color: #f2f2f2; 
            font-weight: bold; 
          }
          
          .invoice-table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 20px;
            margin-top: 0px;
            margin-left: auto;
            margin-right: auto;
          }
          
          .invoice-table th { 
            background-color: #f4f4f4; 
            padding: 8px 10px; 
            text-align: left;  
            font-weight: bold; 
            color: black; 
            font-size: 16px; 
            border-bottom: 2px solid #ddd;
          }
          
          .invoice-table tbody td { 
            padding: 4px 8px; 
            border-bottom: 2px solid #ddd;   
          }

          .invoice-table > tbody:first-of-type tr:last-child td {
            border-bottom: none;
          }
          
          .print-only-total td {
            border-bottom: 2px solid #ddd !important;
          }
          
          .print-only-total.final td {
            border-bottom: 2px solid #ddd !important;
          }
          
          .invoice-table .text-right { 
            text-align: right; 
          }
          
          .total-row { 
            display: flex; 
            justify-content: space-between; 
            padding: 4px 0; 
          }
          
          .total-row.final { 
            border-top: 2px solid #ddd;  
          }
          
          .total-row.subtotal-taxes { 
            border-bottom: 2px solid #ddd;
            padding-bottom: 4px;
            margin-bottom: 2px;
          }
          
          .print-only-total {
            display: none;
          }
          
          .info-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            margin-bottom: 10px;
            width: 100%;
          }
          
          .shipper-info{
            width:180px;
            line-height:1.4;
            word-wrap:break-word;
            overflow-wrap:break-word;
          }
          
          .center-info-container {
            text-align: left;
            font-size: 13px;
            line-height: 1.6;
            flex: 1;
            max-width: 400px;
            margin: 0 auto 0 0;
            margin-left: 0px;
          }
          
          .left-spacer {
            flex: 1;
            visibility: hidden;
          }
          
          .info-line {
            display: flex;
            align-items: baseline;
            margin-bottom: 3px;
            line-height: 1.2;
          }
          
          .info-line strong {
            min-width: auto;
            display: inline;
            font-weight: 600;
            color: #333;
            margin-right: 5px;
          }
          
          .info-line span {
            color: #333;
            font-weight: 500;
          }

          .description-uppercase {
            text-transform: uppercase;
          }
          
          .lab-account-wrapper {
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin: 0;
            padding: 0;
            gap: 80px;
          }

          .lab-info-section {
            flex: 0 0 auto;
            margin-bottom: 10px;
          }

          .lab-info-block {
            margin-bottom: 0;
            padding-bottom: 0;
          }

          .address-line-break {
            display: block;
            word-wrap: break-word;
            overflow-wrap: break-word;
            white-space: normal;
            max-width: 200px;
          }

          .invoice-case-under-logo {
            margin-top: 140px;
            width: fit-content;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          
          .invoice-line,
          .case-line {
            font-size: 30px;
            font-weight: bold;
            color: #000000;
            line-height: 1.2;
            margin: 0;
            text-align: left;
          }
          
          .logo-container {
            position: absolute;
            left: 71%;
            transform: translateX(-50%);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }

          .patient-name-wrap{
            display:inline-block;
            max-width:180px;
            word-wrap:break-word;
            overflow-wrap:break-word;
            white-space:normal;
          }

          @media print {
            .lab-account-wrapper {
              gap: 150px;
              margin: 30px 0 30px 0;
            }

            .lab-info-section {
              margin-right: 25px;
            }

            .lab-info-block {
              margin-bottom: 50px;
              padding-bottom: 25px;
            }

            .invoice-table th,
            .invoice-table td {
              border: 1px solid #3D3D3D !important;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              background: transparent !important;
              text-align: center !important;
              margin-top: 0;
            }

            .invoice-table th:first-child,
            .invoice-table td:first-child {
              border-right: none !important;
            }

            .invoice-table th:nth-child(2),
            .invoice-table td:nth-child(2) {
              border-left: none !important;
            }

            .invoice-table th:first-child,
            .invoice-table td:first-child {
              width: 70%;
              text-align: left;
            }

            .invoice-table th:nth-child(2),
            .invoice-table td:nth-child(2) {
              width: 15%;
              text-align: center;
            }

            .invoice-table th:nth-child(3),
            .invoice-table td:nth-child(3) {
              width: 17.5%;
              text-align: right;
            }

            .invoice-table th:nth-child(4),
            .invoice-table td:nth-child(4) {
              width: 17.5%;
              text-align: right;
            }
            
            .invoice-table td:first-child {
              text-align: left !important;
            }
            
            .totals {
              display: none !important;
            }

            .print-only-total {
              display: table-row !important;
            }

            .print-only-total td {
              border-top: 2px solid #ddd !important;
              border-bottom: 2px solid #ddd !important;
            }

            .print-only-total.final td {
              border-top: 2px solid #3D3D3D !important;
              border-bottom: 2px solid #3D3D3D !important;
            }
            
            .print-only-total td {
              border-top: 1px solid #3D3D3D !important;
              padding: 4px 8px;
            }
            
            .print-only-total td:nth-child(2) {
              border-right: none !important;
            }

            .print-only-total td:nth-child(3) {
              border-left: none !important;
            }

            .print-only-total.subtotal td {
              border-top: 2px solid #3D3D3D !important;
            }

            .print-only-total.final td {
              border-top: 2px solid #3D3D3D !important;
              border-bottom: 2px solid #3D3D3D !important;
            }
            
            .print-only-total td:first-child {
              border-top: none !important;
              border-bottom: none !important;
            }
            
            .print-only-total.subtotal td:first-child {
              border-top: none !important;
              border-bottom: none !important;
            }

            .print-only-total.final td:first-child {
              border-top: none !important;
              border-bottom: 2px solid #3D3D3D !important;
            }
            
            .invoice-table tbody tr td {
              border-bottom: 1px solid #3D3D3D !important;
            }
            
            .print-only-total td {
              border-bottom: 2px solid #3D3D3D !important;
            }
            
            .patient-line{
              align-items:flex-start;
            }

            .patient-name-wrap{
              display:inline-block;
              max-width:180px;
              word-wrap:break-word;
              overflow-wrap:break-word;
              white-space:normal;
            }

            .address-line-break {
              max-width: 250px;
            }

            .invoice-blue-text {
              color: #004aad !important;
              font-weight: bold;
            }
          }
        </style>
      </head>
      <body>
        <div class="page-wrapper">
          <div class="invoice">
            <div class="content-header">
              <div style="display: flex; flex-direction: column; align-items: flex-start; margin-bottom: 10px;">
                <b>${toUpperCase(labName)}</b>
                ${labAddress}<br/>
                ${labCityStateZip}<br/>
                ${labPhone}
              </div>
              <div class="logo-container">
                <img
                  class="logo"
                  src="/log.png"
                  alt="Logo"
                  onerror="this.style.display='none'"
                />
                <div class="invoice-case-under-logo">
                  <div class="invoice-line">Invoice: ${invoiceData.invoiceNumber}</div>
                  <div class="case-line">Case: ${invoiceData.caseId}</div>
                </div>
              </div>
            </div>
            
            <div class="lab-account-wrapper">
              <div class="lab-info-section">
                <div class="lab-info-block">
                  <div style="position: relative; top: 80px; margin-bottom:15px;">
                    <div style="font-weight: bold; font-size: 14px; margin-bottom: 3px;">${toUpperCase(providerDisplayName)}</div>
                    <div style="font-size: 20px; font-weight: bold; text-transform: uppercase; margin-bottom: 3px;">${toUpperCase(accountName)}</div>
                    <div class="address-line-break" style="text-transform: uppercase; margin-bottom: 2px; white-space: normal; word-wrap: break-word; overflow-wrap: break-word;">
                      ${toUpperCase(fullAddress)}
                    </div>
                    <div style="margin-bottom: 2px;">${accountPhone}</div>
                    ${cityStateZip ? `<div style="text-transform: uppercase; white-space: normal; word-wrap: break-word;">${toUpperCase(cityStateZip)}</div>` : ''}
                  </div>
                </div>
              </div>
            </div>
            
            <div class="info-row">
              <div class="left-spacer"></div>
              <div class="center-info-container">
                <div class="info-line">
                  <strong>Date:</strong> <span>${formattedDate}</span>
                </div>
                <div class="info-line patient-line">
                  <strong>Patient:</strong>
                  <span class="patient-name-wrap">${patientFullName}</span>
                </div>
                <div class="info-line">
                  <strong>Patient Appt:</strong> <span>${appointmentDate}</span>
                </div>
              </div>
              ${invoiceData.shipper ? `
              <div class="shipper-info">
                <strong>Shipper:</strong>
                <span>${invoiceData.shipper}</span>
              </div>
              ` : ''}
            </div>
            
            <table class="invoice-table">
              <thead>
                <tr>
                  <th style="width:55%;">Description</th>
                  <th style="width:12%; text-align:right;">QTY</th>
                  <th style="width:16%; text-align:right;">Rate</th>
                  <th style="width:17%; text-align:right;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${(invoiceData.items || []).map(item => `
                  <tr>
                    <td class="description-uppercase">${toUpperCase(item.description || "")}</td>
                    <td style="text-align:right;">${item.quantity || 0}</td>
                    <td style="text-align:right;">£${item.quantity ? (item.amount / item.quantity).toFixed(2) : "0.00"}</td>
                    <td style="text-align:right;">£${item.amount ? item.amount.toFixed(2) : "0.00"}</td>
                  </tr>
                `).join('')}
                ${generateEmptyRows(18)} 
              </tbody>
              
              <tbody class="print-only-total-group">
                <tr class="print-only-total subtotal">
                  <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;"></td>
                  <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;"></td>
                  <td style="text-align:left; color:#3D3D3D; border-bottom: 2px solid #ddd; padding: 4px 8px;">
                    Subtotal
                  </td>
                  <td style="text-align:right; color:#3D3D3D; border-bottom: 2px solid #ddd; padding: 4px 8px;">
                    £${(invoiceData.subtotal || 0).toFixed(2)}
                  </td>
                </tr>
                <tr class="print-only-total final">
                  <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;"></td>
                  <td style="border-bottom: 2px solid #ddd; padding: 4px 8px;"></td>
                  <td style="text-align:left; color:#3D3D3D; border-bottom: 2px solid #ddd; padding: 4px 8px; font-weight: bold;">
                    Total
                  </td>
                  <td style="text-align:right; color:#3D3D3D; border-bottom: 2px solid #ddd; padding: 4px 8px; font-weight: bold;">
                    £${(invoiceData.total || 0).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </table>
            
            <div class="totals">
              <div class="total-row subtotal-taxes">
                <span>Subtotal</span>
                <span>£${(invoiceData.subtotal || 0).toFixed(2)}</span>
              </div>
              <div class="total-row">
                <span>Tax</span>
                <span>£${(invoiceData.taxes || 0).toFixed(2)}</span>
              </div>
              <div class="total-row final">
                <span>Total</span>
                <span>£${(invoiceData.total || 0).toFixed(2)}</span>
              </div>
            </div>
            <div style="border-bottom: 2px solid #ddd;"></div>
          </div>
        </div>
      </body>
      </html>
    `;
  };

  const handlePrint = () => {
    const htmlContent = generateInvoiceHTML();
    if (!htmlContent) {
      return;
    }

    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);

    let iframeDoc;
    if (iframe.contentDocument) {
      iframeDoc = iframe.contentDocument;
    } else if (iframe.contentWindow) {
      iframeDoc = iframe.contentWindow.document;
    }

    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();

    iframe.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();

      setTimeout(() => {
        if (document.body.contains(iframe)) {
          document.body.removeChild(iframe);
        }
      }, 1000);
    };

    setTimeout(() => {
      if (document.body.contains(iframe)) {
        iframe.contentWindow.print();
        setTimeout(() => {
          if (document.body.contains(iframe)) {
            document.body.removeChild(iframe);
          }
        }, 1000);
      }
    }, 500);
  };
  const handleEditSuccess = (updatedData) => {
  const updatedInvoice = {
    ...updatedData,
    remaining: (parseFloat(updatedData.total) - parseFloat(updatedData.paid || 0)).toFixed(2),
  };
  setInvoiceData(updatedInvoice);

  Swal.fire({
    icon: 'success',
    title: 'Updated!',
    text: 'Invoice has been updated successfully.',
    timer: 2000,
    showConfirmButton: false,
  });
};

const dropdownOptions = [
  { label: 'Print', action: 'Print' },
  { label: 'Save as PDF', action: 'Save Classic PDF' },
  ...(userRole === 'Admin' || visiblePages.includes('Edit Invoice')
    ? [{ label: 'Edit', action: 'Edit' }]
    : []),
  { label: 'Delete', action: 'Delete' },
];

  const handleOptionClick = (option) => {
    setDropdownOpen(false);
    if (option === 'Print') {
      handlePrint();
    } else if (option === 'Save Classic PDF') {
      saveAsPDF(`Invoice-${invoiceData.invoiceNumber || invoiceData.caseId}-Classic.pdf`);
    } else if (option === 'Edit') {
     setShowEditModal(true);
    } else if (option === 'Delete') {
      handleDelete();
    }
  };

  if (loading) {
    return <div style={styles.loadingError}>Loading invoice...</div>;
  }
  
  if (error) {
    return <div style={styles.loadingError}>{error}</div>;
  }
  
  if (!invoiceData) {
    return <div style={styles.loadingError}>Invoice data not available. Please check the invoice number.</div>;
  }

  const displayProviderName = providerInfo?.account_name || invoiceData?.provider_name || 'Provider';
  const displayAccountName = accountInfo?.account_name || invoiceData.accountHolder || '';
  const displayAccountAddress = accountInfo?.address || invoiceData.account_address || '';
  const displayAccountCity = accountInfo?.city || '';
  const displayAccountState = accountInfo?.state || '';
  const displayAccountZip = accountInfo?.zip || '';
  const displayAccountPhone = accountInfo?.telephone || invoiceData.account_phone || '';
  
  const cityStateZipDisplay = `${displayAccountCity}${displayAccountCity && displayAccountState ? ', ' : ''}${displayAccountState} ${displayAccountZip}`.trim();

  const statementDate = invoiceData.statementDate 
    ? formatDate(invoiceData.statementDate) 
    : 'N/A';

  const patientName = invoiceData.patient_name || 
    (invoiceData.patientFirstName && invoiceData.patientLastName 
      ? `${invoiceData.patientFirstName} ${invoiceData.patientLastName}` 
      : 'N/A');

  const appointmentDate = invoiceData.appointmentDate 
    ? formatDate(invoiceData.appointmentDate) 
    : 'N/A';

  const formattedDate = invoiceData?.invoiceDate
    ? formatDate(invoiceData.invoiceDate)
    : 'N/A';

  const patientFullName = toUpperCase(
    `${invoiceData?.patientFirstName || ''} ${invoiceData?.patientLastName || ''}`
  ).trim() || 'N/A';

  return (
    <>
      <Header />
      <Navvbar />
      <TransitionGroup>
        <CSSTransition key={location.key} classNames="fade" timeout={300}>
          <div style={styles.pageContainer}>
            <div className="row g-0">
              <div className="col-md-2 invdt-sidebar" style={styles.sidebar}>
                <h2 className="invdt-sidebar-title" style={styles.sidebarTitle}>Finances</h2>
                <div className="invdt-sidebar-links">
                  <Link to="/postings" className="invdt-sidebar-link" style={styles.sidebarLink}>Postings</Link>
                  <Link to="/Statements" className="invdt-sidebar-link" style={styles.sidebarLink}>Statements</Link>
                </div>
              </div>
              <div className="col-md-10 invdt-content" style={styles.contentWrapper}>
                <div>
                  <div className="invdt-header" style={styles.headerContainer}>
                    <div className="invdt-heading" style={styles.invoiceHeading}>
                      Invoice #{invoiceData.invoiceNumber || 'N/A'} / Case{' '}
                      <Link to={`/case/${invoiceData.caseId}`} style={styles.caseLink}>
                        #{invoiceData.caseId || 'N/A'}
                      </Link>
                    </div>
                    <div style={styles.actionButtonContainer}>
                      <button type="button" className="invdt-action-btn" style={styles.actionButton} onClick={() => setDropdownOpen(!isDropdownOpen)}>
                        Actions ▾
                      </button>
                      {isDropdownOpen && (
                        <div style={styles.dropdown}>
                          {dropdownOptions.map(({ label, action }) => (
                            <div key={label} style={styles.dropdownItem} onClick={() => handleOptionClick(action)}>
                              {label}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Clinic Info + Invoice Details */}
                  <div className="invdt-info-row">
                    <div className="invdt-clinic-wrap" style={{ marginBottom: '20px' }}>
                      <div className="invdt-clinic" style={styles.clinicInfo}>
                        <div style={{
                          fontSize: '18px',
                          fontWeight: '600',
                          color: '#000000',
                          marginBottom: '3px'
                        }}>
                          {displayAccountName}
                        </div>
                        {displayAccountAddress && (
                          <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.4', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                            {displayAccountAddress}
                          </div>
                        )}
                        {cityStateZipDisplay && (
                          <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.4' }}>
                            {cityStateZipDisplay}
                          </div>
                        )}
                        {displayAccountPhone && (
                          <div style={{ fontSize: '13px', color: '#555', lineHeight: '1.4' }}>
                            Tel: {displayAccountPhone}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="invdt-details-grid" style={styles.detailsGrid}>
                      <div className="invdt-details-col" style={styles.detailsColumn}>
                        <div className="invdt-detail-item" style={styles.detailItem}>
                          <div className="invdt-detail-heading" style={styles.detailHeading}>Invoice Date</div>
                          <div className="invdt-detail-value" style={styles.detailValue}>
                            {formatDate(invoiceData.invoiceDate)}
                          </div>
                        </div>

                        <div className="invdt-detail-item" style={styles.detailItem}>
                          <div className="invdt-detail-heading" style={styles.detailHeading}>Statement Date</div>
                          <div className="invdt-detail-value" style={styles.detailValue}>
                            {statementDate !== 'N/A' ? statementDate : ''}
                          </div>
                        </div>

                        <div className="invdt-detail-item" style={styles.detailItem}>
                          <div className="invdt-detail-heading" style={styles.detailHeading}>Provider</div>
                          <div className="invdt-detail-value" style={styles.detailValue}>
                            {displayProviderName || "N/A"}
                          </div>
                        </div>

                        <div className="invdt-detail-item" style={styles.detailItem}>
                          <div className="invdt-detail-heading" style={styles.detailHeading}>Patient</div>
                          <div className="invdt-detail-value" style={{
                            ...styles.detailValue,
                            color: '#004aad',
                            fontWeight: '600'
                          }}>
                            {patientName !== 'N/A' ? patientName : ''}
                          </div>
                        </div>

                        <div className="invdt-detail-item" style={styles.detailItem}>
                          <div className="invdt-detail-heading" style={styles.detailHeading}>Patient Appointment</div>
                          <div className="invdt-detail-value" style={styles.detailValue}>
                            {appointmentDate !== 'N/A' ? appointmentDate : ''}
                          </div>
                        </div>

                        {invoiceData.shipper && (
                          <div className="invdt-detail-item" style={styles.detailItem}>
                            <div className="invdt-detail-heading" style={styles.detailHeading}>Shipper:</div>
                            <div className="invdt-detail-value" style={styles.detailValue}>
                              {invoiceData.shipper}
                            </div>
                          </div>
                        )}

                        {invoiceData.trackNumber && (
                          <div className="invdt-detail-item" style={styles.detailItem}>
                            <div className="invdt-detail-heading" style={styles.detailHeading}>Tracking Ref#:</div>
                            <div className="invdt-detail-value" style={styles.detailValue}>
                              {invoiceData.trackNumber}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* ITEMS TABLE */}
                  <div className="invdt-items" style={styles.itemsSection}>
                    <table style={styles.itemsTable}>
                      <thead>
                        <tr style={styles.tableHeader}>
                          <th style={{ ...styles.tableCell, width: '72%' }}>Description</th>
                          <th style={{ ...styles.tableCell, ...styles.textRight, width: '7%' }}>Qty</th>
                          <th style={{ ...styles.tableCell, ...styles.textRight, width: '10%' }}>Rate</th>
                          <th style={{ ...styles.tableCell, ...styles.textRight, width: '11%' }}>Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(invoiceData.items || []).map((item, index) => (
                          <tr key={item._id || index} style={index % 2 === 0 ? {} : styles.tableRowEven}>
                            <td style={{ ...styles.tableCell, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>{item.description || 'N/A'}</td>
                            <td style={{ ...styles.tableCell, ...styles.textRight, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>{item.quantity || '0'}</td>
                            <td style={{ ...styles.tableCell, ...styles.textRight, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>
                              {formatCurrency(calculateRate(item.amount, item.quantity))}
                            </td>
                            <td style={{ ...styles.tableCell, ...styles.textRight, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>{formatCurrency(item.amount)}</td>
                          </tr>
                        ))}
                        {(!invoiceData.items || invoiceData.items.length === 0) && (
                          <tr>
                            <td colSpan="4" style={{ ...styles.tableCell, borderLeft: 'none', borderRight: 'none', borderTop: 'none' }}>No items in this invoice.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* SUMMARY SECTION */}
                  <div className="invdt-summary" style={styles.summarySection}>
                    <table style={styles.summaryTable}>
                      <tbody>
                        <tr style={styles.summaryRow}>
                          <td style={{
                            ...styles.summaryLabel,
                            borderBottom: 'none',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'left',
                            fontWeight: '600',
                            color: '#444',
                            width: '78%'
                          }}>
                            &nbsp;
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            fontWeight: '600',
                            color: '#444',
                            width: '11%'
                          }}>
                            Subtotal:
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            color: '#333',
                            width: '11%'
                          }}>
                            {formatCurrency(invoiceData.subtotal)}
                          </td>
                        </tr>

                        <tr style={styles.summaryRow}>
                          <td style={{
                            ...styles.summaryLabel,
                            borderBottom: '2px solid #ddd',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'left',
                            fontWeight: '600',
                            color: '#444',
                            width: '68%'
                          }}>
                            &nbsp;
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            fontWeight: '600',
                            color: '#444',
                            width: '16%'
                          }}>
                            Total :
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            color: '#333',
                            width: '16%'
                          }}>
                            {formatCurrency(invoiceData.total || 0)}
                          </td>
                        </tr>

                        <tr style={styles.summaryRow}>
                          <td style={{
                            ...styles.summaryLabel,
                            borderBottom: '2px solid #ddd',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'left',
                            fontWeight: '600',
                            color: '#444',
                            width: '68%'
                          }}>
                            &nbsp;
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            borderRight: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            fontWeight: '600',
                            color: '#444',
                            width: '16%'
                          }}>
                            Paid:
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            padding: '4px 10px',
                            textAlign: 'right',
                            color: '#333',
                            width: '16%'
                          }}>
                            {formatCurrency(invoiceData.paid || 0)}
                          </td>
                        </tr>

                        <tr style={styles.totalRow}>
                          <td style={{
                            ...styles.summaryLabel,
                            borderBottom: '2px solid #ddd',
                            borderRight: 'none',
                            borderTop: '2px solid #ddd',
                            padding: '4px 10px',
                            textAlign: 'left',
                            fontWeight: 'bold',
                            color: '#333',
                            fontSize: '15px',
                            width: '68%'
                          }}>
                            &nbsp;
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            borderRight: 'none',
                            borderTop: '2px solid #ddd',
                            padding: '4px 10px',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            color: '#333',
                            fontSize: '15px',
                            width: '16%'
                          }}>
                            Remaining :
                          </td>
                          <td style={{
                            ...styles.summaryValue,
                            borderBottom: '2px solid #ddd',
                            borderLeft: 'none',
                            borderTop: '2px solid #ddd',
                            padding: '4px 10px',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            color: '#333',
                            fontSize: '15px',
                            width: '16%'
                          }}>
                            {formatCurrency(invoiceData.remaining)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </CSSTransition>
      </TransitionGroup>
      {/* Edit Invoice Modal */}
      <EditInvoice
        isOpen={showEditModal}
        onClose={() => setShowEditModal(false)}
        invoiceData={invoiceData}
        invoiceNumber={invoiceNumber}
        onSuccess={handleEditSuccess}
      />
    </>
  );
};

export default InvoiceDetail;